import type { ISagaModule } from 'redux-dynamic-modules-saga'

import localSagas from './sagas'
import localReducer from './reducer'
import gearModeSagas from './sagas.gearmode'
import playbackReducer from './shared/reducer.playback'

const sagas = [...localSagas, ...gearModeSagas]

const webinarModule: ISagaModule<unknown> = {
  id: 'webinar',
  reducerMap: {
    webinar: localReducer,
    webinarPlayback: playbackReducer,
  },
  sagas,
}

export default webinarModule
